import React from 'react';
import { Redirect } from 'react-router-dom';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import MainTabs from './MainTabs';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from '../components/LoadingScreen';

const ProtectedTabs: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen message="Checking session…" />;
  }

  if (!user) {
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Session Required</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding" fullscreen>
          <p>You are not signed in. Redirecting to login…</p>
        </IonContent>
        <Redirect to="/login" />
      </IonPage>
    );
  }

  return <MainTabs />;
};

export default ProtectedTabs;
